/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {admitStorefrontLoginEntry} from '../api'

export const useMutationAdmitStorefrontLoginEntry = createReactQueryMutationHook('admitStorefrontLoginEntry', admitStorefrontLoginEntry)
